import React from "react"
import styled from "styled-components"
import { NextSeo } from "next-seo"
import { useRouter } from "next/router"
import Link from "next/link"
import day from "dayjs"

import Spacer from "~/components/Spacer"
import DesktopContainer from "~/components/DesktopContainer"
import Layout from "~/components/Pages/BasicWithoutContainer"
import MarkdownComponent from "~/components/Markdown"
import LeftArrow from "~/components/svg/LeftArrow"

import {
  CATEGORIES_LABELS,
  CATEGORIES_URL,
  getCategoryFromUrl
} from "~/components/faq/constants"
import Center from "~/components/basic/Center"
import { buildSlug } from "~/utilities/string"

import articles from "./articles"
import SugguestedArticles from "./SugguestedArticles"

const BackContainer = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  color: ${props => props.theme.colors.text.inputPlaceholder};
  svg {
    margin: 0 10px 00;
  }
`

const Header = styled.div`
  h1 {
    margin: 1.7em 0;
  }
  span {
    text-transform: uppercase;
    font-size: 1.1em;
    color: ${props => props.theme.colors.primary};
    margin: 0 10px;
  }
  margin: 0 0 1em 0;
`

const CategoryPage = () => {
  const router = useRouter()
  let article
  let category
  if (router.query && router.query.category) {
    category = getCategoryFromUrl(router.query.category)
  }
  if (router.query && router.query.slug && router.query.slug.length >= 1) {
    article = articles.find(i => buildSlug(i.title) === router.query.slug[1])
  }
  const notFound = !article || !category
  if (notFound && process.browser) {
    router.replace("/knowledge-base")
  }
  const categoryTitle = category ? CATEGORIES_LABELS[category] : undefined
  return (
    <>
      <NextSeo
        title={`${
          categoryTitle ? `${categoryTitle} ` : ""
        }Knowledge Base | WinIt`}
      />
      <Layout>
        {article ? (
          <>
            <Spacer mobile={10} desktop={10} />
            <DesktopContainer>
              <Link
                href="/knowledge-base/[category]"
                as={`/knowledge-base/${CATEGORIES_URL[category]}`}
                passHref
              >
                <BackContainer>
                  <LeftArrow />
                  {categoryTitle || ""} Knowledge Base
                </BackContainer>
              </Link>
              <Spacer mobile={20} desktop={30} />
              <Center>
                <Header>
                  {article.type.map(i => (
                    <span key={i}>{i}</span>
                  ))}
                  <h1>{article.title}</h1>
                  {article.date && (
                    <span>{day(article.date).format("MMMM D, YYYY")}</span>
                  )}
                </Header>
              </Center>
              <MarkdownComponent src={article.content} />
              <Spacer mobile={30} desktop={30} />
            </DesktopContainer>
            <SugguestedArticles titles={article.suggested} />
          </>
        ) : (
          <Center>
            <h2>We could not find that...</h2>
          </Center>
        )}
      </Layout>
    </>
  )
}

export default CategoryPage
